import React, {Component} from "react"
import {Container, Divider, Form, Header, Icon, Loader} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {setFetchPlanRecommendation, setHealthPlanDetails, setSkipRecommendation} from "../actions/userActions";
import {getLocalization, parseMultilineString} from "../utils/localization";
import Steps from "./steps/steps";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, getStepProps, handleSaveUserProgress, isAnsel, languages, registerSkipRecommendation, SELECT_PLAN_ROUTE} from "../utils/common";
import Footer from "./footer";
import {CustomGrid} from "./custom-common";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        highDeductibleOptions: initialData.highDeductibleOptions,
        coPayOptions: initialData.coPayOptions,
        storedTypicallyPayInfo: user.typicallyPayInfo,
        storedHighDeductibleInfo: user.highDeductibleInfo,
        name: user.name,
        lang: user.lang,
        user, initialData, benAdmin,
        ...ownProps
    }
};

class HealthPlanDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            highDeductibleSelected: props.storedHighDeductibleInfo,
            typicallyPaySelected: props.storedTypicallyPayInfo,
            needsUserProgressUpdate: false,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin, dispatch, prevRoute} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        dispatch(setPrevRoute(prevRoute));
        dispatch(setSkipRecommendation(false));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 1, uiFlow, distributionChannel)});
    }

    handleHighDeductibleChange = (selectedKey) => {
        let {typicallyPaySelected} = this.state;
        const clearWhenVisitingADoctor = this.showVisitingTheDoctorQuestion(selectedKey);
        if(clearWhenVisitingADoctor){
            typicallyPaySelected = null;
        }
        this.setState({highDeductibleSelected: selectedKey, typicallyPaySelected, needsUserProgressUpdate: true});
    };

    handleTypicallyPayChange = (selectedKey) => {
        this.setState({typicallyPaySelected: selectedKey, needsUserProgressUpdate: true});
    };

    showVisitingTheDoctorQuestion = (highDeductibleSelected) => {
        const NOT_COVERED_ID = 3;
        return highDeductibleSelected !== NOT_COVERED_ID;
    }

    registerSkipRecommendationAction() {
        const {initialData: {token}, dispatch} = this.props;
        dispatch(setSkipRecommendation(true));
        registerSkipRecommendation(token);
    }

    render() {
        const {stepProps, highDeductibleSelected, typicallyPaySelected, needsUserProgressUpdate} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.healthPlanDetails;

        const {highDeductibleOptions, coPayOptions, user} = this.props;
        const highDeductibleOpts = highDeductibleOptions.map((o) => {
            return {key: o.id, value: o.id, text: o.value};
        });
        const coPayOpts = coPayOptions.map((o) => {
            return {key: o.id, value: o.id, text: o.value};
        });
        const showCoverageQuestion = this.showVisitingTheDoctorQuestion(highDeductibleSelected);
        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable columns={1}>
                                <CustomGrid.Row>
                                    <CustomGrid.Column>
                                        <Header as="h2">{strings.title}</Header>
                                        <p>{parseMultilineString(strings.subTitle)}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                <CustomGrid.Row>
                                    <CustomGrid.Column>
                                        <Form>
                                            <p className={"requiredField"}><b>{strings.doesYourHealth}</b></p>
                                            <Form.Field>
                                                <Form.Group grouped>
                                                    {highDeductibleOpts.map((r) => {
                                                        let text = r.text;
                                                        const localizationEng = getLocalization(languages.ENGLISH);
                                                        const engStrings = localizationEng.healthPlanDetails;
                                                        if(text === engStrings.yes){
                                                            text = strings.yes;
                                                        } else if(text === engStrings.no){
                                                            text = strings.no;
                                                        } else if(text === engStrings.imNot){
                                                            text = strings.imNot;
                                                        }

                                                        return <React.Fragment key={r.text}>
                                                            <Form.Radio className={'radioNormalFontSize'}
                                                                onChange={() => this.handleHighDeductibleChange(r.key)}
                                                                checked={highDeductibleSelected === r.key}
                                                                label={text}/>
                                                        </React.Fragment>
                                                    })}
                                                </Form.Group>
                                            </Form.Field>
                                            <Divider hidden/>

                                            {showCoverageQuestion && <React.Fragment>
                                                <p className={"requiredField"}><b>{strings.whenVisitingDoctor}</b></p>
                                                <Form.Field>
                                                    <Form.Group grouped>
                                                        {coPayOpts.map((r) => {
                                                            let text = r.text;
                                                            const localizationEng = getLocalization(languages.ENGLISH);
                                                            const engStrings = localizationEng.healthPlanDetails;
                                                            if(text === engStrings.iPay){
                                                                text = strings.iPay;
                                                            } else if(text.trim() === engStrings.theFullCost){
                                                                text = strings.theFullCost;
                                                            }
                                                            return <React.Fragment key={r.text}>
                                                                <Form.Radio key={r.id} className={'radioNormalFontSize'}
                                                                            onChange={() => this.handleTypicallyPayChange(r.key)}
                                                                            checked={typicallyPaySelected === r.key}
                                                                            label={text}/>
                                                            </React.Fragment>
                                                        })}
                                                    </Form.Group>
                                                </Form.Field>
                                            </React.Fragment>
                                            }
                                        </Form>
                                        <Divider hidden/>
                                        {strings.iDontWant}
                                        <span>{' '}
                                            <Link to={SELECT_PLAN_ROUTE} onClick={() => this.registerSkipRecommendationAction()}>
                                                <span>{strings.skip}<Icon name="long arrow alternate right"/></span>
                                            </Link>
                                        </span>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    disabled={highDeductibleSelected === null || (showCoverageQuestion && typicallyPaySelected === null)}
                    onClickCallback={() => {
                        const {dispatch} = this.props;
                        dispatch(setHealthPlanDetails(typicallyPaySelected, highDeductibleSelected));
                        this.props.dispatch(setFetchPlanRecommendation(true));
                        if(needsUserProgressUpdate){
                            const u = {...user}
                            u.typicallyPayInfo = typicallyPaySelected;
                            u.highDeductibleInfo = highDeductibleSelected;
                            handleSaveUserProgress(this.props.initialData.token, u).then();
                        }
                        this.props.history.push(this.props.nextRoute);
                    }}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(HealthPlanDetails));
